import {css} from "@emotion/css";
import {MagazineCategoryService} from "../../serverService/magazineService/MagazineCategoryService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import {
    RaikoButtonPrimary,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDivider,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoLabel,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function MagazineCategoryDetail(
    {
        id = -1,
        categoryInlineItems = [],
        handleUpdateCategoryTree
    }) {

    const service = new MagazineCategoryService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [name, setName] = useState("");
    const [slug, setSlug] = useState("");
    const [parent, setParent] = useState(-1);

    const [categoryInline, setCategoryInline] = useState([]);


    useEffect(() => {
        if (id >= 0) {
            getCategoryDetail()
            prepareCategoryInlineItems()
            getCategoryThumbnail()
            getCategoryIcon()
        }
    }, [id]);

    function prepareCategoryInlineItems() {
        setCategoryInline([])
        if (categoryInlineItems) {
            categoryInlineItems.map(item => {
                if (item.id !== id) {
                    setCategoryInline(prev => [
                        ...prev,
                        item
                    ])
                }
            })
        }
    }

    function getCategoryDetail() {
        loading.show()
        service.getCategoryDetail(id)
            .then(({detail, thumbnail, icon}) => {
                setName(detail.title)
                setParent(detail.parent ? detail.parent.id : -1)
                setSlug(detail.slug)

                setPhotoUrl(thumbnail.url)
                setIconUrl(icon.url)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function getCategoryThumbnail() {
        service.getCategoryThumbnail(id)
            .then(response => {
                setPhotoUrl([response.downloadUrl])
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {

        })
    }

    function getCategoryIcon() {
        service.getCategoryIcon(id)
            .then(response => {
                setIconUrl([response.downloadUrl])
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {

        })
    }


    function checkFields() {
        let state = false
        let message = ""

        if (name.length === 0) {
            message = "لطفا نام درسته بندی را به درستی وارد نمایید"
        } else if (slug.length === 0) {
            message = "لطفا SLUG درسته بندی را به درستی وارد نمایید"
        } else if (parent === id) {
            message = "دسته بندی پدر انتخاب شده صحیح نمی باشد."
        } else
            state = true

        if (message && message.length > 0)
            showWarningMessage(message)

        return state
    }

    function handleUpdateInfo() {
        if (checkFields()) {
            loading.show()
            service.updateCategory(id, name, slug, parent)
                .then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                    handleUpdateCategoryTree()
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    const [photoFile, setPhotoFile] = useState([]);
    const [photoUrl, setPhotoUrl] = useState([]);


    const [iconFile, setIconFile] = useState([]);
    const [iconUrl, setIconUrl] = useState([]);

    function handleUpdateThumbnail() {
        if (photoFile) {
            loading.show()
            service.updateCategoryThumbnail(id, photoFile[0])
                .then(response => {
                    setPhotoUrl(response.url)
                    setPhotoFile("")
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else
            showWarningMessage("ابتدا تصویر مورد نظر خود را انتخاب نمایید")
    }

    function handleUpdateIcon() {
        if (iconFile) {
            loading.show()
            service.updateCategoryIcon(id, iconFile[0])
                .then(response => {
                    setIconUrl(response.url)
                    setIconFile("")
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else
            showWarningMessage("ابتدا تصویر مورد نظر خود را انتخاب نمایید")
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;
          gap: 1.5rem`}>
            <RaikoGridOneColumn>
                <RaikoLabel text={"اطلاعات پایه"} className={css`padding-bottom: .5rem`}/>
                <RaikoGridThreeColumn>
                    <RaikoSimpleInputOutlined
                        labelText={"نام"}
                        setValue={setName}
                        value={name}/>
                    <RaikoSimpleInputOutlined
                        labelText={"Slug"}
                        setValue={setSlug}
                        value={slug}/>
                    <RaikoCustomSelect
                        items={[
                            raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                            ...categoryInline
                        ]}
                        labelText={"پدر"}
                        value={parent}
                        setValue={setParent}
                    />
                </RaikoGridThreeColumn>
                <RaikoFlexAlignEnd>
                    <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdateInfo}/>
                </RaikoFlexAlignEnd>
            </RaikoGridOneColumn>
            <RaikoDivider/>
            <RaikoGridOneColumn>

                <RaikoGridOneColumn>
                    <RaikoLabel text={"تصویر شاخص"} className={css`padding-bottom: .5rem`}/>
                    <UploadPhoto
                        photoFile={photoFile}
                        setPhotoFile={setPhotoFile}
                        photo={photoUrl}
                        setPhoto={setPhotoUrl}
                        title={"تصویر شاخص"}
                    />
                    <RaikoFlexAlignEnd className={css`height: fit-content`}>
                        <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdateThumbnail}/>
                    </RaikoFlexAlignEnd>
                </RaikoGridOneColumn>

                <RaikoDivider/>

                <RaikoGridOneColumn>
                    <RaikoLabel text={"آیکون شاخص"} className={css`padding-bottom: .5rem`}/>
                    <UploadPhoto
                        photoFile={iconFile}
                        setPhotoFile={setIconFile}
                        photo={iconUrl}
                        setPhoto={setIconUrl}
                        title={"آیکون شاخص"}
                    />
                    <RaikoFlexAlignEnd className={css`height: fit-content`}>
                        <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdateIcon}/>
                    </RaikoFlexAlignEnd>
                </RaikoGridOneColumn>
            </RaikoGridOneColumn>

        </RaikoGridOneColumn>
    )
}
